import { Box, IconButton, Badge, Typography, Tabs, Tab } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface NotificationPanelHeaderProps {
  unreadCount: number;
  tabValue: number;
  onTabChange: (value: number) => void;
  onClose: () => void;
  onMarkAllAsRead: () => void;
}

export function NotificationPanelHeader({
  unreadCount,
  tabValue,
  onTabChange,
  onClose,
  onMarkAllAsRead,
}: NotificationPanelHeaderProps) {
  return (
    <>
      <Box
        sx={{
          p: 2,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Notifications
          </Typography>
          <Badge badgeContent={unreadCount} color="primary" />
        </Box>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={(_, v) => onTabChange(v)}>
          <Tab label={`NON LUES (${unreadCount})`} />
          <Tab label="TOUTES" />
        </Tabs>

        {unreadCount > 0 && tabValue === 0 && (
          <Box sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
            <Typography
              variant="caption"
              onClick={onMarkAllAsRead}
              sx={{ cursor: 'pointer', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}
            >
              Marquer tout comme lu
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
}
